import { defineStore } from 'pinia'
import { useSessionStorage } from '@vueuse/core'
import { computed } from 'vue'
export const useTokenStore = defineStore('tokenStore', () => {
  const _initData: {
    token: string
    uid: number
  } = {
    token: '',
    uid: 0
  }
  const tokenStorage = useSessionStorage('__K__TOKEN_DATA', { ..._initData })

  /**
   * 用户token
   */
  const token = computed(() => tokenStorage.value.token)

  const uid = computed(() => tokenStorage.value.uid)


  const setToken = (token: string | undefined | null) => {
    tokenStorage.value.token = token ?? ''
  }

  const setUid = (uid: number) => {
    tokenStorage.value.uid = uid
  }

  const reset = () => {
    tokenStorage.value = { ..._initData }
    console.log('清理token信息', tokenStorage.value)
  }

  return { token, uid, setToken, setUid, reset }
})
